export default {
  title: 'Détails de votre donation',
  informations: {
    title: 'Informations',
    labels: {
      value: 'Valeur totale'
    }
  },
  parts: {
    title: 'Répartition par donataire',
    donee: 'Donataire',
    gauge: {
      text: 'Visualisez le détail de la donation pour ce donataire',
      labels: {
        amount: 'Montant donation',
        available: 'Marge disponible'
      }
    }
  }
}
